export default {

    reportPdf(calculated, status, category, therapistId, communityServiceId, dateStart, dateEnd, successFunc, errorFunc) {
        if (true /*check permissions?*/) {

            let url = 'api/v1/report/create-pdf'
                + '?calc=' + calculated
                + '&status=' + status
                + '&cat=' + category
                + '&therapist=' + therapistId
                + '&community=' + communityServiceId
                + (dateStart ? '&ds=' + dateStart + '' : '' )
                + (dateEnd ? '&de=' + dateEnd + '' : '');

            this.getPdfDocumentByUrl(url, successFunc, errorFunc);
        }
    },

    weeklyLessonsPdf(therapistId, dateStart, dateEnd, successFunc, errorFunc) {

        let url = 'api/v1/report/create-weekly-lessons-pdf'
            + '?therapist=' + therapistId
            + (dateStart ? '&ds=' + dateStart + '' : '' )
            + (dateEnd ? '&de=' + dateEnd + '' : '');

        this.getPdfDocumentByUrl(url, successFunc, errorFunc);
    },

    getPdfDocumentByUrl(url, successFunc, errorFunc) {
        this.getDocumentByUrl(url, 'application/pdf', successFunc, errorFunc);
    },

    getWordDocumentByUrl(url, successFunc, errorFunc) {
        this.getDocumentByUrl(url, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', successFunc, errorFunc);
    },

    getExcelDocumentByUrl(url, successFunc, errorFunc) {
        this.getDocumentByUrl(url, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', successFunc, errorFunc);
    },

    getDocumentByUrl(url, contentType, successFunc, errorFunc) {

        /*
         * use the native xhr request, because vue-resource cant handle arraybuffer!
         * see https://github.com/pagekit/vue-resource/issues/669
         */

        let xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.setRequestHeader('Accept', contentType);
        xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('id_token'));
        xhr.responseType = 'arraybuffer';

        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {

                    let arrayBuffer = xhr.response;
                    let blob = new Blob(
                        [arrayBuffer],
                        {type: contentType + ';charset=utf-8'}
                    );

                    let filename = (xhr.getResponseHeader('content-disposition').split('filename='))[1].replace(/['"]/g, '');
                    this.download(filename, blob);

                    //call success function
                    successFunc()

                } else {
                    //call error function
                    errorFunc()
                }
            }
        };

        xhr.onerror = () => {
            //call error function additionally here
            errorFunc()
        };

        xhr.send(null);
    },

    download(filename, blob) {

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);

        } else { //all normal browsers
            let link = document.createElement('a');
            link.style.display = "none";
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    },
}